(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["uswe-v2-event-list"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const toggles = document.querySelectorAll('.event-toggle');
  const filterBtns = document.querySelectorAll('.filter-btn');
  const showAllBtn = document.getElementById('show-all-events');
  const filterWrapper = document.getElementById('filter-wrapper');
  const eventItems = document.querySelectorAll('[data-event]');
  const dividers = document.querySelectorAll('[data-divider]');

  // --- Accordion Logic ---
  toggles.forEach(toggle => {
    toggle.addEventListener('click', function () {
      const currentEvent = this.closest('[data-event]');
      const isActive = currentEvent.classList.contains('active');

      if (isActive) {
        currentEvent.classList.remove('active');
        if(this.tagName === 'BUTTON') this.textContent = 'Read more';
      } else {
        document.querySelectorAll('[data-event]').forEach(event => {
          event.classList.remove('active');
          const btn = event.querySelector('.event-toggle');
          if (btn && btn.tagName === 'BUTTON') btn.textContent = 'Read more';
        });
        currentEvent.classList.add('active');
        if(this.tagName === 'BUTTON') this.textContent = 'Close';
      }
    });
  });

  // --- Filtering Logic ---
  function filterEvents(category, clickedBtn) {
    // Handle Button Active States
    filterBtns.forEach(btn => btn.classList.remove('active'));
    
    if (clickedBtn) {
      clickedBtn.classList.add('active');
    }

    // Filter Items
    eventItems.forEach((item) => {
      const itemCategory = item.getAttribute('data-category');
      
      // Show if "All" is clicked OR item category matches button OR item is tagged "all"
      if (category === 'all' || itemCategory === category || itemCategory === 'all') {
        item.classList.remove('hidden');
      } else {
        item.classList.add('hidden');
        item.classList.remove('active');
      }
    });

    // Handle Dividers
    dividers.forEach((divider, index) => {
        const isBeforeVisible = !eventItems[index].classList.contains('hidden');
        const hasVisibleAfter = Array.from(eventItems).slice(index + 1).some(el => !el.classList.contains('hidden'));
        
        if (isBeforeVisible && hasVisibleAfter) {
            divider.classList.remove('hidden');
        } else {
            divider.classList.add('hidden');
        }
    });

    // Handle Wrapper Alignment & Show All button visibility
    if (category === 'all') {
      showAllBtn.style.display = 'none';
      filterWrapper.classList.remove('filter-active');
    } else {
      showAllBtn.style.display = 'inline-block';
      filterWrapper.classList.add('filter-active');
    }
  }

  filterBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      const cat = this.getAttribute('data-filter');
      
      // If the clicked button is already active, treat it as "Show All"
      if (this.classList.contains('active')) {
        filterEvents('all', null);
      } else {
        filterEvents(cat, this);
      }
    });
  });

  showAllBtn.addEventListener('click', function() {
    filterEvents('all', null);
  });
});

  } catch(e) { console.error(e); }
})();
})();
